function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { forwardRef, useEffect, useRef, useState } from 'react';
var regex = /simg(.*)\.gaodunwangxiao\.com|s-cdn(.*)\.gaodunwangxiao\.com/;
var domainRegx = /https?:\/\/([^\/]+)/;
var GdImage = function GdImage(props, ref) {
  var _a;
  var src = props.src,
    attrs = __rest(props, ["src"]);
  var _useState = useState(src || ''),
    _useState2 = _slicedToArray(_useState, 2),
    imgUrl = _useState2[0],
    setImgUrl = _useState2[1];
  var backupIndexRef = useRef(-1);
  var backupList = ((_a = window === null || window === void 0 ? void 0 : window.gd) === null || _a === void 0 ? void 0 : _a.imgDomainList) || [];
  var handleImgError = function handleImgError() {
    var _a;
    var urlMatch = src === null || src === void 0 ? void 0 : src.match(regex);
    var domain = (_a = src === null || src === void 0 ? void 0 : src.match(domainRegx)) === null || _a === void 0 ? void 0 : _a[1];
    if (urlMatch && domain) {
      if (backupList.length > 0 && backupIndexRef.current < backupList.length - 1) {
        backupIndexRef.current = backupIndexRef.current + 1;
        var newUrl = src.replace(domain, backupList[backupIndexRef.current]);
        setImgUrl(newUrl);
      } else {
        console.error("Can't reload image by url: " + src);
      }
    }
  };
  useEffect(function () {
    setImgUrl(src || '');
  }, [src]);
  return /*#__PURE__*/React.createElement("img", _extends({
    ref: ref,
    src: imgUrl
  }, attrs, {
    onError: handleImgError
  }));
};
export default /*#__PURE__*/forwardRef(GdImage);